import React from 'react';
import { observer } from 'mobx-react';
import DialogStore from '../stores/DialogStore';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
// import RaisedButton from 'material-ui/RaisedButton';
import { withRouter } from "react-router-dom";

class DialogObj extends React.Component {
  handleClose = () => {
    DialogStore.closeDialog()
  };

  goTo = () => {
    this.props.history.push(`${this.props.goUrl}`)
    DialogStore.closeDialog()
  }

  render() {
    const actions = [
      <FlatButton
        label="取消"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="確定"
        primary={true}
        keyboardFocused={true}
        onClick={this.goTo}
      />,
    ];

    return (
      <div>
        <Dialog
          // title="Dialog With Actions"
          actions={actions}
          modal={false}
          open={DialogStore.show}
          onRequestClose={this.handleClose}
        >
          將切換至{this.props.goTitle}
        </Dialog>
      </div>
    );
  }
}

DialogObj.DefaultProps = {
  goTitle: '',
  goUrl: '',
}

export default withRouter(observer(DialogObj))


// WEBPACK FOOTER //
// ./src/components/Dialog.js